import { config } from '@/config';

// The e-mail/PDF logo lives in this environment's public `public-assets`
// bucket (scripts/copy-logo-to-public-assets.mjs puts it there), so stage and
// production each serve their own copy.
export const EMAIL_LOGO_URL = `${config.SUPABASE_URL}/storage/v1/object/public/public-assets/img-alliant-logo.png`;
